import { Flex, Heading } from '@chakra-ui/react';

import { Carousel } from '../../../../common/carousel';
import { EVENTS_ENG } from 'src/common/constants/englishLabels';
import { EVENTS_HIN } from 'src/common/constants/hindiLabels';
import { EventCard } from './eventCard';
import React from 'react';
import { RootState } from "src/store/store";
import { UpcomingEventList } from 'src/resources/DummyData';
import { useSelector } from "react-redux";

export const UpcomingEvents: React.FC = () => {
    const globalInfo = useSelector((state: RootState) => state.globalInfo);
    const { globalLanguage } = globalInfo;
    const isHindiLabels = globalLanguage === "HI";
    // const navigate = useNavigate();
    // const dispatch = useDispatch<AppDispatch>();


    // const handleViewAll = () => {   
    //     dispatch(addBreadcrumb({ label: "Events", path: AppRoutes.ALL_EVENTS }));
    //     navigate(AppRoutes.ALL_EVENTS)
    // }

    return (
        <Flex direction="column" paddingY={{ base: 8, md: 12, lg: 14}} paddingX="2rem" background="#FFFFFF" height="100%">
            <Flex direction="row" alignItems="center" justifyContent="space-between" width="100%">
                <Heading as="h3" fontWeight="bold">{isHindiLabels? EVENTS_HIN.UPCOMING_EVENTS : EVENTS_ENG.UPCOMING_EVENTS}</Heading>
                {/* <Button _hover={{ background: "#FF7E6B" }} color="white" background="#FF7E6B" onClick={handleViewAll}>
                    {isHindiLabels? BUTTONS_HIN.VIEW_ALL : BUTTONS_ENG.VIEW_ALL}
                </Button> */}
            </Flex>
            <Carousel
                CardComponent={EventCard}
                eventList={UpcomingEventList}
                rows={1}
                slidesToShow={3}
            />
        </Flex>
    );
};
